import { registry } from '@cian/mf-registry/browser';

import { IDesktopFiltersAPI } from 'shared/types/microfrontends';

const desktopFiltersApiCall = async <Params, Result = void>(path: string, params?: Params): Promise<Result> => {
  const api = await registry().microfrontendStrict('desktop-filters-micro-frontend').api()?.ensure();

  return api?.call(path, params) as Result;
};

export const getDesktopFiltersMicrofrontendApi = (): IDesktopFiltersAPI => {
  return {
    openGeoModal: () => {
      return desktopFiltersApiCall<void, void>('/v1/open-geo-modal');
    },
    openDatesPopup: () => {
      return desktopFiltersApiCall<void, void>('/v1/open-dates-popup');
    },
  };
};
